/**
 * @generated SignedSource<<ecd13760fdef6ccfc5084c8ede42e60f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "CreateCompanyPayload",
            "kind": "LinkedField",
            "name": "createCompany",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfCompany",
                    "kind": "LinkedField",
                    "name": "companyEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Company",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SignupPage_createCompanyMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SignupPage_createCompanyMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "e7792db5437232a5dcdfbc0e9c9a8573",
            "id": null,
            "metadata": {},
            "name": "SignupPage_createCompanyMutation",
            "operationKind": "mutation",
            "text": "mutation SignupPage_createCompanyMutation(\n  $model: CreateCompanyRequestInput!\n) {\n  createCompany(model: $model) {\n    companyEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "34e169f2da10206ca62c8e6b032e8783";
export default node;
